import { proxy } from 'valtio';

/**
 * 本次会议录音时长 store
 * 与 RecordingDurationStore（全局用量计数）不同，这里只跟踪单次会议的录音秒数
 * 支持暂停/恢复：stop 时累加已录时长，start 时从累加值继续
 */
export const MeetingDurationStore = proxy({
  /** 当前会议累计录音秒数（含暂停前的时长） */
  currentDuration: 0,
  /** 暂停前已累计的秒数 */
  accumulatedDuration: 0,
  /** 本次录音段的开始时间戳（ms），null 表示未在录音 */
  recordingStartTime: null as number | null,
  /** 定时器 id */
  _timerId: null as number | null,
});

/** 开始计时（录音开始时调用） */
export function startMeetingTimer() {
  if (MeetingDurationStore.recordingStartTime !== null) return; // 已在计时
  MeetingDurationStore.recordingStartTime = Date.now();

  MeetingDurationStore._timerId = window.setInterval(() => {
    if (MeetingDurationStore.recordingStartTime !== null) {
      const elapsed = Math.floor((Date.now() - MeetingDurationStore.recordingStartTime) / 1000);
      MeetingDurationStore.currentDuration = MeetingDurationStore.accumulatedDuration + elapsed;
    }
  }, 1000);
}

/** 停止计时（录音暂停/停止时调用） */
export function stopMeetingTimer() {
  // 清除定时器
  if (MeetingDurationStore._timerId !== null) {
    clearInterval(MeetingDurationStore._timerId);
    MeetingDurationStore._timerId = null;
  }
  // 将本段录音时长累加
  if (MeetingDurationStore.recordingStartTime !== null) {
    const elapsed = Math.floor((Date.now() - MeetingDurationStore.recordingStartTime) / 1000);
    MeetingDurationStore.accumulatedDuration += elapsed;
    MeetingDurationStore.currentDuration = MeetingDurationStore.accumulatedDuration;
  }
  MeetingDurationStore.recordingStartTime = null;
}

/** 重置（发起新会议时调用） */
export function resetMeetingTimer() {
  if (MeetingDurationStore._timerId !== null) {
    clearInterval(MeetingDurationStore._timerId);
    MeetingDurationStore._timerId = null;
  }
  MeetingDurationStore.currentDuration = 0;
  MeetingDurationStore.accumulatedDuration = 0;
  MeetingDurationStore.recordingStartTime = null;
}
